<style scoped>
.no-margin-bottom {
  margin-bottom: 0px;
}
.padding-bottom-10 {
  padding-bottom: 10px;
}
.pagination-wrapper {
  margin: 32px 0;
}
.mu-input {
  font-size: 14px;
}
.mu-icon-button.mu-button-small {
  width: 24px;
  height: 24px;
}
.mu-form-item .mu-button {
  margin: 3px 4px;
}
.model-question-radio {
  margin-left: 2px;
  margin-right: 2px;
}
.comment-filter-checkbox {
  margin-left: 2px;
  margin-right: 2px;
}
.mu-divider-bottom {
  margin-bottom: 4px;
}
.mu-form-item {
  margin-bottom: 0px;
  padding-bottom: 0px;
  min-height: 0px;
}
.mu-input {
  margin-bottom: 0px;
  padding-bottom: 0px;
  min-height: 0px;
}
.quick-access-wrapper {
  padding-left: 8px;
  padding-right: 8px;
  align-items: center;
  display: flex;
}
.display-settings-wrapper {
  padding-left: 8px;
  padding-right: 8px;
}
.hint-message {
  padding-left: 4px;
  padding-right: 4px;
}
.tag {
  margin-right: 8px;
}
</style>

<template>
  <mu-card>
    <mu-form :model="form">
      <mu-form-item prop="input" class="no-margin-bottom">
        <mu-text-field
          multi-line :rows="1" :rows-max="6"
          v-model="modelComment"
          @focus.stop.prevent="onFocusInput" @blur.stop.prevent="onFocusOutInput"
          :placeholder="placeholderInput"
          @change="onAutoSave(modelComment)"
          ref="input"
          >
          <transition name="fade">
            <mu-button small flat type="submit" color="primary" @click.stop.prevent="checkInput" v-if="((typeof this.modelComment === 'string' && this.modelComment !== '') || this.modelAttachment.length > 0 || this.modelAudio.length > 0 ) && checkTag"><mu-icon value="send"/> {{$t('comment.submit')}}</mu-button>
          </transition>
          <emoji-picker @emoji="insert" :search="search" slot="append">
            <mu-button small icon slot="emoji-invoker"
            slot-scope="{ events }"
            v-on="events" class="md-icon-button" v-tooltip="$t('comment.emoji')"><mu-icon value="face" /></mu-button>
            <div slot="emoji-picker" slot-scope="{ emojis, insert, display }">
            <div class="emoji-picker" :style="{ right: '50px', bottom: '0px' }">
              <div class="emoji-picker__search">
              <input type="text" v-model="search" v-focus>
              </div>
              <div>
              <div v-for="(emojiGroup, category) in emojis" :key="category">
                <h5>{{ category }}</h5>
                <div class="emojis">
                <span v-for="(emoji, emojiName) in emojiGroup" :key="emojiName" @click="insert(emoji)" :title="emojiName">{{ emoji }}</span>
                </div>
              </div>
              </div>
            </div>
            </div>
          </emoji-picker>
          <mu-select v-model="modelType" slot="prepend" style="margin-left: 4px; width: 240px;" v-if="tagIdForRangeMode === ''">
            <mu-icon :color="typeColor" :value="typeIcon" slot="prepend"/>
            <mu-option :value="i.value" :label="i.text" v-for="i in typeOptions" />
          </mu-select>
          <mu-button
            small icon
            :color="attachmentCollapse ? 'primary' : ''"
            @click.stop.prevent="attachmentCollapse = !attachmentCollapse"
            v-tooltip="$t('comment.attachment')"
            slot="append"
            v-if="tagIdForRangeMode === ''"
            >
            <mu-icon value="attachment" />
          </mu-button>
          <mu-button
            small icon
            :color="voiceCollapse ? 'primary' : ''"
            @click.stop.prevent="voiceCollapse = !voiceCollapse"
            slot="append"
            v-if="tagIdForRangeMode === ''"
            >
            <mu-icon value="mic" />
          </mu-button>
          <mu-button small icon @click.stop.prevent="settingDialog = true" v-if="isAdmin" slot="append" v-tooltip="$t('comment.settings')"><mu-icon value="settings" /></mu-button>
          <mu-checkbox v-model="modelAnomymous" :label="$t('comment.anomymous')" v-if="anomymous"/>
          <mu-chip class="tag" v-if="tagIdForRangeMode !== ''" :style="{ 'color': tagColor, 'background-color': tagBgColor }" slot="prepend" @delete="onClearTag" delete>
            {{ tagById ? tagById.name : '' }} - {{ stringTimestamp(timestampStart) }} {{timestampEnd !== -2 ? ( timestampEnd !== -1 ? ' - ' + stringTimestamp(timestampEnd) : '?') : '' }}
          </mu-chip>
          <mu-chip class="tag" v-if="tagIdForRangeMode === '' && commentTrigger && (this.media.type == 'video' || this.media.type == 'youtube' || this.media.type == 'mp4link')" slot="prepend" @delete="commentTrigger = false" delete >
            {{ stringTimestamp(timestampComment) }}
          </mu-chip>
        </mu-text-field>
        <VoiceInput
          v-if="voiceCollapse"
          v-model="modelAudio"
          />
        <attachment-browser
          class="full-width"
          v-if="attachmentCollapse"
          @onUpdateAttachments="onUpdateAttachments"
          :initIds="modelAttachment"
          />
      </mu-form-item>
      <mu-button flat small @click="collapse = !collapse" class="float-right">
        {{$t('comment.collapse')}} <mu-icon :value="collapse ? 'expand_less' : 'expand_more'"/>
      </mu-button>
      <div class="full-width hint-message">
        <small>{{$t('comment.hint')}}</small>
      </div>
      <div class="clearfix" />
      <div v-if="collapse" class="display-settings-wrapper full-width">
        <div class="clearfix" />
        <mu-form-item prop="select" :label="$t('comment.sort.display')" style="width: 150px; margin-left: 4px; padding-bottom: 0px; margin-bottom: 4px; min-height: 0px;" class="float-right">
          <mu-select v-model="sortBy">
            <mu-option v-for="(option, index) in allSortBy" :key="option.value" :label="option.text" :value="option.value"></mu-option>
            <mu-button small icon :color="sortDir ? 'secondary' : 'primary'" small @click.stop.prevent="sortDir = !sortDir" slot="prepend">
              <mu-icon :value="sortDir ? 'arrow_downward' : 'arrow_upward'"/>
            </mu-button>
          </mu-select>
        </mu-form-item>
        <mu-form-item prop="checkbox" :label="$t('comment.filter.type')">
          <mu-checkbox class="comment-filter-checkbox" v-for="type in allFilters" v-model="filters" :label="type.text" :value="type.value"/>
        </mu-form-item>
        <mu-select filterable v-model="tagsFilter" multiple chips :label="$t('comment.filter.tag')" v-if="tags.length > 0 && media.custom_tag">
          <mu-option v-for="tag, index in tags" :key="tag._id" :label="tag.name" :value="tag._id"></mu-option>
          <template slot="selection" slot-scope="scope">
            <mu-chip :selected="scope.selected" :style="styleTag(tags.find(i => i._id == scope.value))" delete @delete="tagsFilter.splice(scope.index, 1)">
              {{scope.label}}
            </mu-chip>
          </template>
        </mu-select>
        <div class="clearfix" />
      </div>
      <mu-divider class="mu-divider-bottom"/>
    </mu-form>
    <div v-loading="flagFetchingComments">
      <transition name="fade">
        <div v-if="flagFetchedMedia && flagFetchedComments">
          <transition-group name="list" tag="div" v-if="computedComments.length > 0">
            <comment-item
              :comment="comment"
              v-for="(comment, index) in computedComments"
              :key="comment._id"
              :id="'comment-' + comment._id"
              :index="index"
              :css="false"
              :mediaType="media.type"
              :media="media"
              :adminUserIds="adminUserIds"
              :anomymous="anomymous"
              @before-enter="beforeEnter"
              @enter="enter"
              @leave="leave"
              @onActionDelete="onActionDelete(index)"
              @onClickTimestamp="onClickTimestamp"
              @onFinishedDelete="onFinishedDelete"
              @onUpdate="onUpdate"/>
          </transition-group>
          <mu-flex justify-content="center" v-else class="padding-bottom-10">
            {{$t('comment.empty')}}
          </mu-flex>
        </div>
      </transition>
      <mu-dialog :title="$t('comment.settings')" width="360" :open.sync="settingDialog">
        <mu-list>
          <mu-divider></mu-divider>
          <mu-list-item>
            <mu-list-item-action>
              <mu-icon value="record_voice_over"></mu-icon>
            </mu-list-item-action>
            <mu-list-item-content>
              <mu-list-item-title>{{$t('comment.allowAnomymous')}}</mu-list-item-title>
            </mu-list-item-content>
            <mu-list-item-action>
              <mu-switch v-model="anomymous" @change="onChangeAnomymous"></mu-switch>
            </mu-list-item-action>
          </mu-list-item>
          <mu-divider></mu-divider>
          <mu-list-item button :ripple="false" @click="onActionExport">
            <mu-list-item-action>
              <mu-icon value="get_app"></mu-icon>
            </mu-list-item-action>
            <mu-list-item-content>
              <mu-list-item-title>{{$t('comment.export')}}</mu-list-item-title>
            </mu-list-item-content>
          </mu-list-item>
          <mu-divider></mu-divider>
        </mu-list>
        <mu-button slot="actions" flat color="primary" @click="settingDialog = false">{{$t('button.confirm')}}</mu-button>
      </mu-dialog>
      <mu-dialog :title="$t('comment.sendEmail')" width="600" max-width="80%" :esc-press-close="false" :overlay-close="false" :open.sync="toggleEmailPrompt">
        <mu-button slot="actions" flat color="primary" @click="onActionAddCommentWithoutEmail">No</mu-button>
        <mu-button slot="actions" flat color="primary" @click="onActionAddCommentWithEmail">Yes</mu-button>
      </mu-dialog>
    </div>
  </mu-card>
</template>

<script>

// Components
import CommentItem from '@/components/Discussion/CommentItem.vue'
import AttachmentBrowser from '@/components/Common/AttachmentBrowser.vue'
import VoiceInput from '@/components/Common/VoiceInput.vue'

import timeFormatter from '@/utils/timeFormatter.js'

// Library
import axios from "axios";

// Library
import EmojiPicker from 'vue-emoji-picker'

export default {
  name: 'DiscussionTab',
  components: {
    CommentItem,
    AttachmentBrowser,
    EmojiPicker,
    VoiceInput,
  },
  props: {
    mediaId: {
      type: String,
      required: true
    },
    currentTime: {
      type: Number,
      required: true
    },
    isAdmin: {
      type: Boolean,
      default: false
    },
    adminUserIds: {
      type: Array,
      default() {
        return [];
      }
    },
    tag: {
      type: Object,
      default() {
        return {
          action: '',
          tagId: ''
        }
      }
    },
    tagTrigger: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      // Object
      media: "", // Media object
      comments: [], // Comment list
      tags: [],
      search: '',
      form: {},
      filters: ['question', 'comment', 'reaction', 'annotation'],
      sortBy: "created_at",
      sortDir: true, // False = ascending; True = desending
      tagsFilter: [],

      // Flag
      flagFetchedMedia: false, // Boolean variable for status of fetched media
      flagFetchedComments: false, // Boolean variable for status of fetched comments
      flagSnackBarErr: false, // Boolean variable for status of snackbar
      flagSending: false, // Boolean variable for status of sending
      flagFetchingComments: false,
      flagFetchedTag: false,

      // Model
      modelComment: "", // Bind with comment input
      modelAnomymous: false,
      modelType: 'comment',
      modelAttachment: [],
      modelAudio: [],
      collapse: false,
      quick: false,
      settingDialog: false,
      anomymous: true,
      attachmentCollapse: false,
      toggleEmailPrompt: false,
      voiceCollapse: false,
      timestampComment: 0,
      commentTrigger: false,
      timestampStart: 0,
      timestampEnd: -1,
      tagIdForRangeMode: "",

      // String
      msgError: "", // Error message showing in snackbar

      toast: null,
    }
  },
  computed: {
    // Number
    totalPages() {
      return Math.ceil(parseFloat(this.commentTotalCount) / parseFloat(this.itemsPerPage));
    },
    commentTotalCount() {
      return this.computedComments.length;
    },
    
    // Type related
    typeColor() {
      if(this.modelType === 'comment') {
        return 'primary';
      } else if (this.modelType === 'question') {
        return 'secondary';
      } else if (this.modelType === 'annotation') {
        return 'success';
      }
    },
    typeIcon() {
      if(this.modelType === 'comment') {
        return 'comment';
      } else if (this.modelType === 'question') {
        return 'question_answer';
      } else if (this.modelType === 'annotation') {
        return 'sms';
      }
    },

    // Collection
    allSortBy() {
      return [
        { value: 'created_at', text: this.$t('comment.sort.time') },
        { value: 'timestamp', text: this.$t('comment.sort.timestamp') },
      ]
    },
    typeOptions() {
      var arr = [
        { value: 'question', text: this.$t('comment.mode.question') },
        { value: 'comment', text: this.$t('comment.mode.comment') },
        { value: 'annotation', text: this.$t('comment.mode.annotation') },
      ];
      return arr;
    },
    allFilters() {
      var arr = [
        { value: 'question', text: this.$t('comment.mode.question') },
        { value: 'comment', text: this.$t('comment.mode.comment') },
        { value: 'annotation', text: this.$t('comment.mode.annotation') },
      ];
      if(this.media.custom_tag) {
        arr.push({ value: 'reaction', text: this.$t('vote.display') })
      }
      return arr;
    },

    // Store
    triggerRefresh() {
      return this.$store.getters.triggerRefresh;
    },

    computedComments() {
      if(this.comments.length > 0) {
        var comments = this.comments.filter(comment => {
          if(!this.filters.includes('question')) {
            if(comment.question === true || comment.type === 'question') {
              return false;
            }
          }
          if(!this.filters.includes('comment')) {
            if(comment.question === false || comment.type === 'comment') {
              return false;
            }
          }
          if(!this.filters.includes('annotation')) {
            if(comment.type === 'annotation') {
              return false;
            }
          }
          if(!this.filters.includes('reaction')) {
            if(comment.hasOwnProperty('tag_id')) {
              return false;
            }
          } else {
            if(comment.hasOwnProperty('tag_id') && !this.tagsFilter.includes(comment.tag_id)) {
              return false;
            }
          }
          return true;
        });
        comments.sort((a, b) => {
          var sort = this.sortBy;
          if(a[this.sortBy] < b[this.sortBy]) {
            if(this.sortDir)  {
              return 1;
            } else {
              return -1;
            }
          }
          if(a[this.sortBy] > b[this.sortBy]) {
            if(this.sortDir)  {
              return -1;
            } else {
              return 1;
            }
          }
          return 0;
        });
        return comments;
      } else {
        return [];
      }
    },

    tagsFilteredList() {
      if(this.comments.length > 0) {
        return this.comments.filter(comment => comment.tag_id).filter(comment => this.tagsFilter.includes(comment.tag_id));
      }
      return [];
    },
    quickAccessNextList() {
      if(this.tagsFilteredList.length > 0) {
        var temp = this.tagsFilteredList.slice(0);
        temp.sort((a,b) => a.timestamp - b.timestamp)
        return temp.filter(comment => comment.timestamp > this.currentTime);
      }
      return [];
    },
    quickAccessPreviousList() {
      if(this.tagsFilteredList.length > 0) {
        var temp = this.tagsFilteredList.slice(0);
        temp.sort((a,b) => b.timestamp - a.timestamp)
        return temp.filter(comment => comment.timestamp < this.currentTime);
      }
      return [];
    },

    tagById() {
      if(this.tagIdForRangeMode !== '') {
        return this.tags.find(i => i._id === this.tagIdForRangeMode);
      } else {
        return false;
      }
    },
    tagColor() {
      if(this.tagIdForRangeMode !== '') {
        if (this.tagById && typeof this.tagById.color != 'undefined')
          return "rgba(" + this.tagById.color.r + ", " + this.tagById.color.g + ", " + this.tagById.color.b + ", " + this.tagById.color.a + ")";
        else
          return "rgba(255,255,255,1)";
      } else {
        return "rgba(255,255,255,1)";
      }
    },
    tagBgColor() {
      if(this.tagIdForRangeMode !== '') {
        if (this.tagById && typeof this.tagById.color != 'undefined')
          return "rgba(" + this.tagById.backgroundColor.r + ", " + this.tagById.backgroundColor.g + ", " + this.tagById.backgroundColor.b + ", " + this.tagById.backgroundColor.a + ")";
        else
          return "rgba(0,0,0,0.5)";
      } else {
        return "rgba(255,255,255,1)";
      }
    },

    placeholderInput() {
      return this.$t('typeHere');
    },

    checkTag() {
      if(this.tag.tagId === '') {
        return true;
      } else {
        if(this.tag.action === 'start') {
          return false;
        } else {
          return true;
        }
      }
    },
  },
  watch: {
    mediaId() {
      this.fetchComments();
      this.fetchTags();
    },
    triggerRefresh() {
      this.fetchComments();
      this.fetchTags();
    },
    filters: {
      handler(newValue) {
        this.currentPage = 1;
      },
      deep: true
    },
    sortBy() {
      this.$forceUpdate();
    },
    tagTrigger() {
      this.$nextTick(() => {
        if(this.tag.action === 'start') {
          this.tagIdForRangeMode = this.tag.tagId;
          this.timestampStart = this.currentTime;
          this.timestampEnd = -1;
          setTimeout(() => {
            this.$refs.input.$el.getElementsByTagName("textarea")[1].focus();
          }, 100);
        } else if(this.tag.action === 'end') {
          this.timestampEnd = this.currentTime;
        } else if(this.tag.action === 'click') {
          this.tagIdForRangeMode = this.tag.tagId;
          this.timestampStart = this.currentTime;
          this.timestampEnd = -2;
          setTimeout(() => {
            this.$refs.input.$el.getElementsByTagName("textarea")[1].focus();
          }, 100);
        } else if(this.tag.action === 'clear') {
          this.tagIdForRangeMode = '';
          this.timestampStart = 0;
          this.timestampEnd = -1;
        }
      });
    },
  },
  mounted() {
    this.fetchMedia();
    this.fetchComments();
    this.fetchTags();
    this.initAutoSave();
  },
  methods: {
    initAutoSave() {
      if (typeof(Storage) !== "undefined") {
        // Code for localStorage/sessionStorage.
        this.modelComment = localStorage.getItem("comment-" + this.mediaId);
      } else {
        // Sorry! No Web Storage support..
      }
    },
    onAutoSave(str) {
      if (typeof(Storage) !== "undefined") {
        // Code for localStorage/sessionStorage.
        localStorage.setItem("comment-" + this.mediaId, str);
      } else {
        // Sorry! No Web Storage support..
      }
    },
    // List Effect
    beforeEnter(el) {
      el.style.opacity = 0
      el.style.height = 0
    },
    enter(el, done) {
      var delay = el.dataset.index * 150
      setTimeout(function() {
        Velocity(
          el, {
            opacity: 1,
            height: '1.6em'
          }, {
            complete: done
          }
        )
      }, delay)
    },
    leave(el, done) {
      var delay = el.dataset.index * 150
      setTimeout(function() {
        Velocity(
          el, {
            opacity: 0,
            height: 0
          }, {
            complete: done
          }
        )
      }, delay)
    },

    // Fetch
    fetchMedia() {
      axios.get(this.$store.getters.urlApi + "media/" + this.mediaId, {
        headers: {
          token: this.$store.state.auth.token
        }
      }).then(response => {
        this.media = response.data.data.media;
        this.anomymous = this.media.hasOwnProperty('anomymous') ? this.media.anomymous : true;
        this.flagFetchedMedia = true;
      });
    },
    fetchComments() {
      this.flagFetchingComments = true;
      axios.get(this.$store.getters.urlApi + "comment/media/" + this.mediaId, {
        headers: {
          token: this.$store.state.auth.token
        }
      }).then(response => {
        this.comments = response.data.data.comments;
        this.flagFetchedComments = true;
        this.flagFetchingComments = false;
      }).catch(() => {
        this.flagFetchingComments = false;
      });
    },
    fetchTags() {
      axios.get(this.$store.getters.urlApi + "tag/media/" + this.mediaId, {
        headers: {
          token: this.$store.state.auth.token
        }
      }).then(response => {
        if(response.data.data.tags) {
          this.tags = response.data.data.tags;
          this.tagsFilter = this.tags.map(i => i._id);
        }
        this.flagFetchedTag = true;
      });
    },

    // Event
    onActionDelete(i) {
      this.$delete(this.comments, i);
    },
    checkInput() {
      if (this.modelComment === "" && this.modelAudio.length > 0 && this.modelAttachment.length > 0) {
        this.msgError = this.$t('comment.emptyMsg');
        this.flagSnackBarErr = true;
      } else {
        if(this.modelType === 'question') {
          this.toggleEmailPrompt = true;
        } else if(this.modelType === 'comment' || this.modelType === 'annotation') {
          this.onActionAddCommentWithoutEmail();
        }
      }
    },
    onActionAddCommentWithoutEmail() {
      this.onActionAddComment(false);
    },
    onActionAddCommentWithEmail() {
      this.onActionAddComment(true);
    },
    onActionAddComment(needEmail) {
      this.toggleEmailPrompt = false;
      if(this.tagIdForRangeMode === '') {
        if (!this.flagSending) {
          this.flagSending = true;
          axios.post(this.$store.getters.urlApi + "comment/media/" + this.mediaId, {
            'content': typeof this.modelComment === 'string' ? this.modelComment : '',
            'timestamp': Math.floor(this.timestampComment),
            'attachments': this.modelAttachment,
            'audio': this.modelAudio,
            'type': this.modelType,
            'anomymous': this.modelAnomymous,
            'needEmail': needEmail
            }, {
            headers: {
              token: this.$store.state.auth.token,
              'content-type': 'application/json'
            },
          }).then(() => {
            this.modelComment = "";
            this.onAutoSave(this.modelComment);
            this.currentPage = 1;
            this.fetchComments();
            this.flagSending = false;
            this.timestampComment = 0;
            this.commentTrigger = false;
            this.modelAttachment = [];
            this.modelAudio = [];
            this.attachmentCollapse = false;
            this.$toast.success(this.$t('toast.create'));
          });
        }
      } else {
        this.onActionVote();
      }
    },
    onActionVote() {
      var data = {
        'timestamp': Math.floor(this.timestampStart),
        'content': this.modelComment
      };
      data['timestampEnd'] = Math.floor(this.timestampEnd);
      axios.post(this.$store.getters.urlApi + "comment/media/" + this.mediaId + '/tag/' + this.tagIdForRangeMode, data, {
        headers: {
          token: this.$store.state.auth.token,
          'content-type': 'application/json'
        },
      }).then(() => {
        this.modelComment = "";
        this.onAutoSave(this.modelComment);
        this.fetchComments();
        this.$toast.success(this.$t('toast.create'));
        this.modelComment = "";
        this.timestampStart = 0;
        this.timestampEnd = -1;
        this.$store.commit('triggerRefresh');
      });
    },
    onFocusInput(payload) {
      if(!this.commentTrigger) {
        this.timestampComment = this.currentTime;
        this.commentTrigger = true;
      }
      this.$emit('onPause', payload);
    },
    onFocusOutInput() {
      this.$emit('onPlay');
    },
    onClickTimestamp(time) {
      this.$emit('onClickTimestamp', time);
    },
    onFinishedDelete(i) {
      this.$delete(this.comments, i);
      this.fetchComments();
    },
    onUpdateAttachments(payload) {
      this.modelAttachment = payload;
    },
    onUpdate() {
      this.fetchComments();
    },
    onActionExport() {
      this.toast = this.$toasted.show(this.$t('comment.export') + this.$t('toast.process'), {icon: 'hourglass_empty', duration : null});
      var url = this.$store.getters.urlApi + "job/comments/media/" + this.media._id;
      axios({
        method: 'get',
        url: url,
          headers: {
            token: this.$store.state.auth.token
          },
        }).then(response => {
          var uid = response.data.data.uid;
          this.fetchJobProgress(uid);
        })
        .catch(err => {
          console.log(err.message)
        });
    },
    fetchJobProgress(uid) {
      this.interval = setInterval(() => {
        axios({
          method: 'get',
          url: this.$store.getters.urlApi + "job/progress/" + uid,
            headers: {
              token: this.$store.state.auth.token
            },
          }).then(response => {
            if(response.data.data.result)
              this.onJobDone(uid);
          })
          .catch(err => {
            console.log(err.message)
          });
      }, 3000);
    },
    onJobDone(uid) {
      clearInterval(this.interval);

      this.toast.goAway(0);
      axios({
        method: 'get',
        url: this.$store.getters.urlApi + 'file?path=csv/' + uid + '.csv',
          headers: {
            token: this.$store.state.auth.token
          },
          responseType: 'arraybuffer'
      }).then(res => {
        let blob = new Blob([res.data], { type: 'text/csv' });
        let link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = this.media.name + '_comments_' + new Date().getTime() + '.csv';
        link.click();
      })
      .catch(err => {
        console.log(err.message)
      });
    },
    onChangeAnomymous(value) {
      axios.put(this.$store.getters.urlApi + "media/" + this.media._id, {
        'anomymous': value
        }, {
        headers: {
          token: this.$store.state.auth.token
        }
      }).then(() => {
        this.modelAnomymous = false;
      });
    },

    onClearTag() {
      this.$emit('onClickTag', {
        action: 'clear',
        tagId: ''
      })
    },

    // Emoji
    insert(emoji) {
      if(typeof this.modelComment !== 'string') {
        this.modelComment = '';
      }
      this.modelComment += emoji
    },

    styleTag(tag) {
      return {
        color: this.stringColor(tag),
        backgroundColor: this.stringBgColor(tag),
      };
    },
    stringColor(tag) {
      if (typeof tag.color != 'undefined')
        return "rgba(" + tag.color.r + ", " + tag.color.g + ", " + tag.color.b + ", " + tag.color.a + ")";
      else
        return "rgba(255,255,255,1)";
    },
    stringBgColor(tag) {
      if (typeof tag.backgroundColor != 'undefined')
        return "rgba(" + tag.backgroundColor.r + ", " + tag.backgroundColor.g + ", " + tag.backgroundColor.b + ", " + tag.backgroundColor.a + ")";
      else
        return "rgba(0,0,0,0.5)";
    },

    stringTimestamp(timestamp) {
      return timeFormatter(timestamp);
    },
  },
}
</script>
